<template>
    <div class="resolution-switch">
        <span @click="setResolution(1080)" :class="{ 'active disable-element': resolution == 1080 }">1080</span>
        <span @click="setResolution(1440)" :class="{ 'active disable-element': resolution == 1440 }">1440</span>
    </div>
</template>

<script>
import { mapActions, mapState } from "vuex";

export default {
    name: "ResolutionSwitch",
    computed: {
        ...mapState({
            resolution: state => state.StarterPc.resolution
        })
    },
    methods: {
        ...mapActions({
            setResolution: "StarterPc/setResolution"
        })
    }
}
</script>

<style lang="scss" scoped>
@import "~@s/_asset-mixers.scss";

.resolution-switch {
    display: flex;
    border-radius: 2px;
    overflow: hidden;

    span {
        padding: 8px 40px;
        background-color: $black;
        color: #8d29a0;
        font-size: 14px;
        font-weight: bold;
        display: flex;
        justify-content: center;
        align-items: center;
        cursor: pointer;

        &.active {
            background-color: #8d29a0;
            color: $white;
        }
    }
}
</style>
